import ToggleTipPositionImage from '@images/components/toggle-tip/1_toggletips-position.png';
import * as React from 'react';
export default {
  ToggleTipPositionImage,
  React
};